import { PageMeta } from "@/components/common/PageMeta";
import { ScrollSection } from "@/components/main-page/ScrollSection";
import { IRSubNav } from "@/components/ir/IRSubNav";

export function PortalPlaceholder() {
  return (
    <>
      <PageMeta
        title="Investor Portal | COSX"
        description="Authenticated investor portal with reporting dashboards, document management, and quarterly updates."
        path="/ir/portal"
        noindex
      />

      <div className="relative z-10 pt-[var(--topnav-height)] px-8">
        <div className="max-w-6xl mx-auto w-full pt-8">
          <IRSubNav />
        </div>
      </div>

      <ScrollSection id="portal" title="Investor Portal" subtitle="The investor portal with authenticated access, reporting dashboards, and document management is under development." compact>
        <div className="border border-dashed border-[var(--color-border)] p-12 flex items-center justify-center">
          <span className="text-xs text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)]">
            Coming soon
          </span>
        </div>
      </ScrollSection>
    </>
  );
}
